/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

export type ExecutionSource = typeof ExecutionSource[keyof typeof ExecutionSource];


export const ExecutionSource = {
  api: 'api',
  admin_api: 'admin_api',
  publisher_api: 'publisher_api',
  worker: 'worker',
  system: 'system',
} as const;
